import { render, staticRenderFns } from "./infoManagement.vue?vue&type=template&id=8c6ca7b4&scoped=true&"
import script from "./infoManagement.vue?vue&type=script&lang=js&"
export * from "./infoManagement.vue?vue&type=script&lang=js&"
import style0 from "./infoManagement.vue?vue&type=style&index=0&id=8c6ca7b4&scoped=true&lang=css&"
import style1 from "./infoManagement.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6ca7b4",
  null
  
)

export default component.exports